export default __webpack_public_path__ + "static/media/threepoint.07d5ca46.svg";